import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { SizeSpacing8, SizeSpacing32 } from 'autogen/design-tokens/global/tokens';
import type { DrawerActions } from '../shared/types';

const FooterContainer = styled.div`
    padding: ${SizeSpacing32};
    background-color: ${({ theme }) => theme.ColorBackgroundSecondary};
    border-top: 1px solid ${({ theme }) => theme.ColorBorderSecondary};
`;

export type FooterRendererProps = DrawerActions;

export function DefaultFooter({ children, ...restProps }: FooterRendererProps & { children?: ReactNode }) {
    return <FooterContainer {...restProps}>{children}</FooterContainer>;
}

const StyledDefaultFooter = styled(DefaultFooter)`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(124px, 1fr));
    gap: ${SizeSpacing8};
`;

export function DefaultActionFooter({ children, ...restProps }: FooterRendererProps & { children?: ReactNode }) {
    return <StyledDefaultFooter {...restProps}>{children}</StyledDefaultFooter>;
}

const DefaultFooterRenderer = Object.assign(DefaultFooter, { Action: DefaultActionFooter });

export default DefaultFooterRenderer;
